
import { mapGetters, mapMutations, mapActions } from "vuex";
import { Fancybox } from "@fancyapps/ui";
import { Carousel } from "@fancyapps/ui";
// import { Thumbs } from "@fancyapps/ui/dist/carousel/carousel.thumbs.esm.js";
// import "@fancyapps/ui/dist/carousel/carousel.thumbs.css";

import AOS from "aos";
export default {
  props: {
    propsOffer: {
      type: Object,
      default: null
    },
    isNewCar:{
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: ""
    },
    isModal: {
      type: Boolean,
      default: false
    },
    noButton: {
      type: Boolean,
      default: false
    },
    noVin: {
      type: Boolean,
      default: false
    },

    inStock: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ready: false,
      thumbsSwiper: null,
      sl1: null,
      sl2: null
    };
  },
  computed: {
    ...mapGetters({
      offer: "catalog/catalog-cars/offer",
      likesArray: "favorite/favorite/likesArray",
      carPageLoaded: "catalog/catalog-cars/carPageLoaded"
    }),
    currentOffer() {
      return this.propsOffer ? this.propsOffer : this.offer;
    },
    slidesPerView() {
      if (this.$device.isMobile) {
        return 1.1;
      } else {
        return 2;
      }
    },
    centeredSlides() {
      return this.$device.isMobile;
    },
    slidesSpaceBetween() {
      if (this.$device.isMobile) {
        return 8;
      } else {
        return 24;
      }
    }
  },
  methods: {
    ...mapActions({
      liked: "favorite/favorite/liked",
      openModal: "modal/modal-main/openModal",
      closeModal: "modal/modal-main/closeModal"
    }),
    ...mapMutations({
      setOffer: "catalog/catalog-cars/SET_OFFER",
      setCarPageLoaded: "catalog/catalog-cars/SET_CAR_PAGE_LOADED"
    }),
    async like() {
      if (!this.currentOffer) return;
      await this.liked(this.currentOffer.external_id);
    },

    initSliders() {
      if (!this.currentOffer || !this.currentOffer.id) return;
      
      const container = document.getElementById(
        `offerSlider${this.tag ? this.tag : ''}`
      );
      if (!container) return;

      const options = {
        infinite: true,
        center: false,
        transition: "slide",
        slidesPerPage: 1,
        Navigation: {
          nextTpl: "",
          prevTpl: "",
          classes: {
            container: "f-carousel__nav",
            button: "f-button button__arrow",
            isNext: "is-next ",
            isPrev: "is-prev button__arrow--left"
          }
        },
        on: {
          init: () => {
            this.setCarPageLoaded(true);
          }
        }
      };
      const fc = new Carousel(container, options);

      const containerMini = document.getElementById(
        `offerSliderMini${this.tag ? this.tag : ''}`
      );
      if (!containerMini) return;

      const optionsMini = {
        axis: "y",
        infinite: true,
        center: false,
        transition: "slide",
        Sync: {
          target: fc
        },
        slidesPerPage: 1,
        Dots: false,
        Navigation: false
      };
      const thumb = new Carousel(containerMini, optionsMini);

      AOS.init({
        once: true
      });
    },

    initFancybox() {
      if (!this.currentOffer || !this.currentOffer.id) return;
      
      Fancybox.bind(
        `[data-fancybox="gallery-slider-${this.currentOffer.id}-${this.tag}"]`,
        {
          groupAll: true,
          compact: this.$device.isMobile ? true : false,
          Hash: false
        }
      );
      Fancybox.bind(
        `[data-fancybox="gallery-slider-${this.currentOffer.id}-touch-${this.tag}"]`,
        {
          groupAll: true,
          compact: this.$device.isMobile ? true : false,
          Hash: false
        }
      );
    }
  },
  destroyed() {
    if (!this.isModal) this.setOffer(null);
  },
  mounted() {
    if (this.currentOffer && this.currentOffer.id) {
      this.initSliders();
      this.initFancybox();
    }
  },
  watch: {
    currentOffer(value) {
      if (value && value.id) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initSliders();
            this.initFancybox();
          }, 100);
        });
      }
    }
  }
};
